import React from 'react';
import { Route, Switch } from 'react-router-dom';
import asyncComponent from '../../utilities/asyncComponent';

import { isStaff } from '../../utilities/userRoles';

import NoMatch from '../NoMatch';
import { connect } from 'react-redux';

const MEDRoute = asyncComponent(() =>
  import('./MEDRoute').then(module => module.default)
);

const MEDOverview = asyncComponent(() =>
  import('./MEDOverview').then(module => module.default)
);

const MEDKpis = asyncComponent(() =>
  import('./MEDKpis').then(module => module.default)
);

const MEDKpiDemo = asyncComponent(() =>
  import('./MEDKpiDemo').then(module => module.default)
);

const MEDCapitalPlanning = asyncComponent(() =>
  import('./MEDCapitalPlanning').then(module => module.default)
);

const MEDPrevMaintenance = asyncComponent(() =>
  import('./MEDPrevMaintenance').then(module => module.default)
);

const MEDUtilities = asyncComponent(() =>
  import('./MEDUtilities').then(module => module.default)
);

const MEDRenewables = asyncComponent(() =>
  import('./MEDRenewables').then(module => module.default)
);

const MEDInsightsSavings = asyncComponent(() =>
  import('./MEDInsightsSavings').then(module => module.default)
);

const MEDInsightsAnalytics = asyncComponent(() =>
  import('./MEDInsightsAnalytics').then(module => module.default)
);

const MEDInsightsOpportunities = asyncComponent(() =>
  import('./MEDInsightsOpportunities').then(module => module.default)
);

const MEDResourcesAbout = asyncComponent(() =>
  import('./MEDResourcesAbout').then(module => module.default)
);

const MEDResourcesFaqs = asyncComponent(() =>
  import('./MEDResourcesFaqs').then(module => module.default)
);

const MEDResourcesTerms = asyncComponent(() =>
  import('./MEDResourcesTerms').then(module => module.default)
);

const MEDResourcesTour = asyncComponent(() =>
  import('./MEDResourcesTour').then(module => module.default)
);

const MEDResourcesLinks = asyncComponent(() =>
  import('./MEDResourcesLinks').then(module => module.default)
);

const MEDResourcesFacilityDetails = asyncComponent(() =>
  import('./MEDResourcesFacilityDetails').then(module => module.default)
);

const MEDLiveMap = asyncComponent(() =>
  import('./MEDLiveMap').then(module => module.default)
);

const MEDFoghorn = asyncComponent(() =>
  import('./MEDFoghorn').then(module => module.default)
);

const MEDCharting = asyncComponent(() =>
  import('./MEDCharting').then(module => module.default)
);

const MEDPowerBiEmbedded = asyncComponent(() =>
  import('./MEDPowerBiEmbedded').then(module => module.default)
);

const MEDPowerMonitoring = asyncComponent(() =>
  import('./MEDPowerMonitoring').then(module => module.default) 
);

const AdminRoute = asyncComponent(() =>
  import('../Admin/AdminRoute').then(module => module.default)
);

const AnalyticsDetailChart = asyncComponent(()=>
  import('./AnalyticsDetailChart').then(module=>module.default)
)

const MEDRoutes = ({ role: role, match: { path } }) => {
  return (
    <>
      <Switch>
        <MEDRoute
          component={MEDOverview}
          exact
          path={`${path}`}
          sectionName={'section.overview'}
        />
        <MEDRoute
          component={MEDOverview}
          exact
          path={`${path}/overview`}
          sectionName={'section.overview'}
        />
        <MEDRoute
          component={MEDKpis}
          path={`${path}/kpis`}
          sectionName="section.kpis"
        />
        <MEDRoute
          component={MEDKpiDemo}
          path={`${path}/kpisdemo`}
          sectionName="section.kpisdemo"
        />
        <MEDRoute
          component={MEDCapitalPlanning}
          path={`${path}/capital_planning`}
          sectionName="section.capitalPlanning"
        />
        <MEDRoute
          component={MEDPrevMaintenance}
          path={`${path}/preventative_maintenance`}
          sectionName="section.prevMaintenance"
        />
        <MEDRoute
          component={MEDUtilities}
          path={`${path}/utilities`}
          sectionName="section.utilities"
        />
        <MEDRoute
          component={MEDRenewables}
          path={`${path}/renewables`}
          sectionName="section.renewables"
        />
        <MEDRoute
          component={MEDInsightsSavings}
          path={`${path}/insights/savings`}
          sectionName="section.insights_savings"
        />
        <MEDRoute
          component={MEDInsightsOpportunities}
          path={`${path}/insights/opportunities`}
          sectionName="section.insights_opportunities"
        />
        <MEDRoute
          exact
          component={MEDInsightsAnalytics}
          path={`${path}/insights/analytics`}
          sectionName="section.insights_analytics"
        />
        <MEDRoute
          component={AnalyticsDetailChart}
          path={`${path}/insights/analytics/:taskId`}
          sectionName="section.insights_analytics"
        />
        <MEDRoute
          component={MEDResourcesAbout}
          path={`${path}/resources/about`}
          sectionName="section.resources_about"
        />
        <MEDRoute
          component={MEDResourcesFaqs}
          path={`${path}/resources/faqs`}
          sectionName="section.resources_faqs"
        />
        <MEDRoute
          component={MEDResourcesTerms}
          path={`${path}/resources/terms_and_concepts`}
          sectionName="section.resources_terms"
        />
        <MEDRoute
          component={MEDResourcesTour}
          path={`${path}/resources/tour`}
          sectionName="section.resources_tour"
        />
        <MEDRoute
          component={MEDResourcesLinks}
          path={`${path}/resources/links`}
          sectionName="section.resources_links"
        />
        <MEDRoute
          component={MEDResourcesFacilityDetails}
          path={`${path}/resources/facility_details`}
          sectionName="section.resources_details"
        />
        <MEDRoute
          component={MEDResourcesAbout}
          path={`${path}/resources`}
          sectionName="section.resources"
        />
        <MEDRoute
          component={MEDLiveMap}
          path={`${path}/livemap`}
          sectionName="section.livemap"
        />
        <MEDRoute
          component={MEDFoghorn}
          path={`${path}/foghorn`}
          sectionName="section.foghorn"
        />
        <MEDRoute
          component={MEDCharting}
          path={`${path}/charting`}
          sectionName="section.charting"
        />
        <MEDRoute
          component={MEDPowerBiEmbedded}
          path={`${path}/powerbi_embedded`}
          sectionName="section.powerbi_embedded"
        />
        <MEDRoute
          component={MEDPowerMonitoring}
          path={`${path}/power_monitoring`}
          sectionName="section.power_monitoring"
        />
        {/* --- McKinstry Internal --- */}
        {isStaff(role) && (
          <Route path={`${path}/admin`} component={AdminRoute} />
        )}
        {/* --- Catch All 404 --- */}
        <MEDRoute component={NoMatch} path="*" sectionName="404" />
      </Switch>
    </>
  );
};
const mapStateToProps = state => ({
  role: state.auth.role,
});

export default connect(mapStateToProps)(MEDRoutes);
